import React, { useState, useMemo} from 'react'
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useTranslation } from 'react-i18next'
import { Alert, Card, CardBody, Col, NavItem, Row } from 'reactstrap'
import { NavLink } from 'react-router-dom'
import classnames from "classnames"
import { Link } from 'react-router-dom'
import collectedImg from "assets/images/cards/revenue/collected.png"
import earningsImg from "assets/images/cards/revenue/earnings.png"
import revenueImg from "assets/images/cards/revenue/revenue.png"
import RevenueTable from "./RevenueTable"
import { FilterByDateRangeModal } from 'components/Extra/FilterByDateRangeModal'
import { FilterByIdRangeModal } from 'pages/vendor/Revenue/Modals'

export interface OrderRow {
  orderId: string
  orderDate: string
  totalOrders: number
  revenueQAR: number
  earningsQAR: number
  commissionQAR: number
  status: "Collected" | "Not Collected"
}

const revenueData: OrderRow[] = [
  {
    orderId: "1",
    orderDate: "01 Nov, 2021",
    totalOrders: 50,
    revenueQAR: 100,
    earningsQAR: 70,
    commissionQAR: 30,
    status: "Collected",
  },
  {
    orderId: "2",
    orderDate: "02 Nov, 2021",
    totalOrders: 10,
    revenueQAR: 100,
    earningsQAR: 70,
    commissionQAR: 30,
    status: "Not Collected",
  },
  {
    orderId: "3",
    orderDate: "03 Nov, 2021",
    totalOrders: 30,
    revenueQAR: 100,
    earningsQAR: 70,
    commissionQAR: 30,
    status: "Collected",
  },
  {
    orderId: "4",
    orderDate: "04 Nov, 2021",
    totalOrders: 10,
    revenueQAR: 100,
    earningsQAR: 70,
    commissionQAR: 30,
    status: "Collected",
  },
  {
    orderId: "5",
    orderDate: "05 Nov, 2021",
    totalOrders: 5,
    revenueQAR: 100,
    earningsQAR: 70,
    commissionQAR: 30,
    status: "Collected",
  },
  {
    orderId: "6",
    orderDate: "06 Nov, 2021",
    totalOrders: 10,
    revenueQAR: 100,
    earningsQAR: 70,
    commissionQAR: 30,
    status: "Not Collected",
  },
  {
    orderId: "7",
    orderDate: "07 Nov, 2021",
    totalOrders: 10,
    revenueQAR: 100,
    earningsQAR: 70,
    commissionQAR: 30,
    status: "Collected",
  },
]

export const Revenue = () => {
    const { t } = useTranslation()
    const [activeTab, toggleTab] = useState("1")
    const [periodType, setPeriodType] = useState("Today")
    const [checkedRows, setCheckedRows] = useState<OrderRow[]>([])
    
  const cardsData: {
    title: string
    total: number | string
    img: string
  }[] = useMemo(() => {
    return [
      {
        title: t("revenue_revenue"),
        total: 25000,
        img: revenueImg,
      },
      {
        title: t("revenue_earnings"),
        total: 21000,
        img: earningsImg,
      },
      {
        title: t("revenue_commissionTaken"),
        total: 4000,
        img: collectedImg,
      },
      {
        title: t("revenue_collected"),
        total: 20000,
        img: collectedImg,
      },
    ]
  }, [t])

    const onChangeChartPeriod = (pType: string) => {
    setPeriodType(pType)
    }

  const isAllChecked = revenueData.length > 0 && checkedRows.length === revenueData.length

  const toggleAllRows = () => {
    if (isAllChecked) {
      setCheckedRows([])
    } else {
      setCheckedRows([...revenueData])
    }
  }

  const checkedRowHandler = (row: OrderRow) => {
    const isChecked = checkedRows.some(checkedRow => checkedRow.orderDate === row.orderDate)

    if (isChecked) {
      setCheckedRows(checkedRows.filter(checkedRow => checkedRow.orderDate !== row.orderDate))
    } else {
      setCheckedRows([...checkedRows, row])
    }
  }

  const onDateRangeChange = (startDate: string, endDate: string) => {
    console.log("Selected date range:", startDate, "to", endDate)
  }
  const onIdRangeChange = (startId: string, endId: string) => {
    console.log("Selected ID range:", startId, "to", endId)
  }

  return (
    <div className="page-content d-flex flex-column">
      <div className="container-fluid p-0 gap-3 d-flex flex-column">
        <Breadcrumbs
          title={t("dashboard_dashboard")}
          breadcrumbItem={t("revenue_revenue")}
        />

        <ul
          className="nav nav-tabs nav-tabs-custom justify-content-start pt-2 gap-3"
          style={{ justifyContent: "start" }}
          role="tablist"
        >
          {[
            { id: "1", label: t("revenue_byDate") },
            { id: "2", label: t("revenue_byOrder") },
          ].map(tab => (
            <NavItem key={tab.id}>
              <NavLink
                to="#"
                className={classnames({
                  active: activeTab === tab.id,
                })}
                onClick={() => {
                  toggleTab(tab.id)
                }}
                style={{
                  color:
                    activeTab === tab.id
                      ? "var(--bs-primary) !important"
                      : "inherit !important",
                  borderColor:
                    activeTab === tab.id ? "var(--bs-primary)" : "transparent",
                  borderBottomWidth: activeTab === tab.id ? "2px" : "1px",
                  borderBottomStyle: "solid",
                }}
              >
                {tab.label}
              </NavLink>
            </NavItem>
          ))}
          {activeTab === "1" ? (
            <FilterByDateRangeModal onDateRangeChange={onDateRangeChange} />
          ) : (
            <FilterByIdRangeModal onIdRangeChange={onIdRangeChange} />
          )}
        </ul>

        <Row className="d-flex justify-content-between align-items-end gap-3">
          <Col md="6" xs="12">
            <Alert className="mb-0" color="cyan">
              {t("revenue_note")}
            </Alert>
          </Col>

          <Col xs="12" md="5" className="d-flex justify-content-end">
            <ul
              className="nav nav-pills p-0 d-flex justify-content-end py-3 px-1"
              style={{ width: "fit-content", background: "transparent" }}
            >
              {[
                { key: "Today", label: t("revenue_today") },
                { key: "Week", label: t("revenue_week") },
                { key: "Month", label: t("revenue_month") },
              ].map((period, index) => (
                <li key={period.key} className="nav-item">
                  <Link
                    to="#"
                    className={classnames(
                      { active: periodType === period.key },
                      `px-3 py-3 ${index === 0 ? "rounded-start" : ""} ${
                        index === 2 ? "rounded-end" : ""
                      } ${periodType === period.key ? "bg-gradiant-blue" : ""}`
                    )}
                    style={
                      periodType === period.key
                        ? {
                            color: "white !important",
                            borderRadius: "0px !important",
                            border: "0.5px solid var(--bs-primary)",
                            borderLeftWidth: index !== 1 ? "0px" : "0.5px",
                            borderRightWidth: index !== 1 ? "0px" : "0.5px",
                          }
                        : {
                            background:
                              "linear-gradient(94.68deg, #095BA8 4.7%, #00A0DC 94.6%)",
                            WebkitBackgroundClip: "text",
                            WebkitTextFillColor: "transparent",
                            backgroundClip: "text",
                            borderRadius: "0px !important",
                            border: "0.5px solid var(--bs-primary)",
                            borderLeftWidth: index !== 1 ? "0px" : "0.5px",
                            borderRightWidth: index !== 1 ? "0px" : "0.5px",
                          }
                    }
                    onClick={() => {
                      onChangeChartPeriod(period.key)
                    }}
                    id={`one_${period.key}`}
                  >
                    {period.label}
                  </Link>
                </li>
              ))}
            </ul>
          </Col>
        </Row>

        <Row className="mt-3">
          {cardsData.map((report, key) => (
            <Col sm="6" md="4" lg="3" key={"_col_" + key}>
              <Card className="mini-stats-wid shadow-md rounded-3">
                <CardBody>
                  <div className="d-flex">
                    <div className="flex-grow-1">
                      <p className="text-muted fw-medium text-capitalize">
                        {report.title}
                      </p>
                      <div className="d-flex gap-1 align-items-baseline justify-content-start">
                        <h6 className="mb-0">{t("common_qar")}</h6>
                        <h4 className="mb-0">
                          {report.total.toLocaleString()}
                        </h4>
                      </div>
                    </div>
                    <div className="avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                      <span className="avatar-title rounded-circle bg-primary">
                        <img
                          src={report.img}
                          alt={report.title}
                          className="img-fluid"
                        />
                      </span>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>

        <RevenueTable
          revenueData={revenueData}
          isAllChecked={isAllChecked}
          checkedRows={checkedRows}
          toggleAllRows={toggleAllRows}
          checkedRowHandler={checkedRowHandler}
          activeTab={activeTab}
        />
      </div>
    </div>
  )
}
